import React, { memo } from 'react'
import { getMergedClassNames } from '../../utils/HTMLutils'
import './DropdownItem.scss'
const rootClassName = 'component-dropdown-item'

interface DropdownItemProps {
  icon?: object
  label?: string
  disabled?: boolean
  onClick?: (event?: any) => void
  alignRight?: boolean
}

function DropdownItem(props: DropdownItemProps) {
  return (
    <button
      disabled={props.disabled}
      className={getMergedClassNames([
        rootClassName,
        props.alignRight ? 'align-right' : ''
      ])}
      onClick={(evt) => {
        if (typeof props.onClick === 'function' && !props.disabled) {
          props.onClick(evt)
        }
      }}
    >
      {props.icon && !props.alignRight ? (
        <div className={`${rootClassName}-icon`}>{props.icon}</div>
      ) : undefined}
      <div className={`${rootClassName}-label`}>{props.label}</div>
      {props.icon && props.alignRight ? (
        <div className={`${rootClassName}-icon right`}>{props.icon}</div>
      ) : undefined}
    </button>
  )
}

export default memo(DropdownItem)
